// @ts-nocheck
import * as Types from "../../../../types/types-v2.generated";

import { gql } from "@apollo/client";
export type LogStatsViewServerFragment = {
  __typename?: "Server";
  logStats: Array<{
    __typename?: "LogStat";
    bucketStart: string;
    classification?: string | null;
    count: number;
  }>;
  logQuota: { __typename?: "LogQuota"; overQuotaBytes: number };
};

export const LogStatsViewServerFragmentDoc = gql`
  fragment LogStatsViewServer on Server {
    logStats(from: $from, to: $to, databaseId: $databaseId) {
      bucketStart
      classification
      count
    }
    logQuota(from: $from, to: $to) {
      overQuotaBytes
    }
  }
`;
